import { Route, mapToCanActivate } from '@angular/router';
import { MsalGuard } from '@azure/msal-angular';
import { FeatureFlags } from '@core/enumeration/featureFlags';
import { CreateAuthPacGuard, FeatureToggleGuard } from '@core/guards';
import { RouterFragments } from '@core/model/RouterFragments';
import { PortalProducts } from '@shared/enumeration';
import { AccessPageGuard } from '@mynexus/mynexus-ui-lib';
import { ProviderDashboardComponent } from '../pages/provider-dashboard/provider-dashboard.component';

export default [
  {
    path: `:tenantId/pac-im/auth-dashboard/${RouterFragments.UNKNOWN}`,
    loadChildren: () =>
      import(
        '@pages/auth-detail-not-found/auth-detail-not-found.module'
      ).then((m) => m.AuthDetailNotFoundModule),
    data: { title: 'Auth Details Not Found' },
    canActivate: mapToCanActivate([MsalGuard]),
  },
  {
    path: `:tenantId/pac-commercial/auth-dashboard/${RouterFragments.UNKNOWN}`,
    loadChildren: () => import('@pages/auth-detail-not-found/auth-detail-not-found.module').then((m) => m.AuthDetailNotFoundModule),
    data: { title: 'Auth Details Not Found' },
    canActivate: mapToCanActivate([MsalGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.PACIM}/auth-dashboard/:authorizationNumber`,
    loadChildren: () => import('@pages/auth-details-pacim-view/auth-details-pacim-view.module').then((m) => m.AuthDetailsPacimViewModule),
    data: {
      title: 'Auth Details',
      permissions: ['PACIMAuthorization.Read'],
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.PacCommercial}/auth-dashboard/:authorizationNumber`,
    loadChildren: () => import('@pages/auth-details-pac-commercial/auth-details-pac-commercial.module').then((m) => m.AuthDetailsPacCommercialModule),
    data: {
      permissions: ['PACIMAuthorization.Read'],
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.PACIM}/continued-stay/:authorizationNumber`,
    loadChildren: () => import('@pages/continued-stay-pac/continued-stay-pac.module').then((m) => m.ContinuedStayPacModule),
    data: {
      title: 'Continued Stay Request',
      permissions: ['ContinuedStayRequest.Create'],
      productName: PortalProducts.PACIM
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: `:tenantId/${PortalProducts.PacCommercial}/continued-stay/:authorizationNumber`,
    loadChildren: () => import('@pages/continued-stay-pac/continued-stay-pac.module').then((m) => m.ContinuedStayPacModule),
    data: {
      permissions: ['ContinuedStayRequest.Create'],
      productName: PortalProducts.PacCommercial
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard]),
  },
  {
    path: ':tenantId/pac-im/member/:memberId/request-initial',
    loadChildren: () => import('@pages/auth-request-pacim-initial/auth-request-pacim-initial.module')
      .then((m) => m.AuthRequestPacImInitialModule),
    data: {
      title: 'Authorization Request',
      permissions: ['PACIMAuthorization.Create'],
      featureAccess: FeatureFlags.PACIM,
    },
    canActivate: mapToCanActivate([
      MsalGuard,
      FeatureToggleGuard,
      AccessPageGuard,
      CreateAuthPacGuard,
    ]),
  },
  {
    path: ':tenantId/pac-im/member/:memberId/request-pending/recommendation/:recommendationId',
    loadChildren: () => import('@pages/auth-request-pending/auth-request-pending.module')
      .then((m) => m.AuthRequestPendingModule),
    data: {
      title: 'Authorization Request',
      permissions: ['PendingRequest.Read'],
      featureAccess: FeatureFlags.PACPendingRequestDashboard,
    },
    canActivate: mapToCanActivate([
      MsalGuard,
      FeatureToggleGuard,
      AccessPageGuard,
    ]),
  },
  {
    path: ':tenantId/pac-commercial/member/:memberId/request-initial',
    loadChildren: () =>
      import(
        '@pages/auth-request-pac-commercial/auth-request-pac-commercial.module'
      ).then((m) => m.AuthRequestPacCommercialModule),
    data: {
      permissions: ['PACIMAuthorization.Create'],
    },
    canActivate: mapToCanActivate([
      MsalGuard,
      AccessPageGuard,
      CreateAuthPacGuard,
    ]),
  },
  {
    path: ':tenantId/provider-dashboard',
    component: ProviderDashboardComponent,
    data: {
      permissions: ['ProviderDashboard.Read'],
    },
    canActivate: mapToCanActivate([AccessPageGuard]),
  },
  {
    path: ':tenantId/pending-requests-dashboard',
    loadChildren: () => import('@pages/pending-requests-dashboard/pending-requests-dashboard.module')
      .then((m) => m.PendingRequestsDashboardModule),
    data: {
      permissions: ['PendingRequest.Read'],
      featureAccess: FeatureFlags.PACPendingRequestDashboard,
    },
    canActivate: mapToCanActivate([MsalGuard, AccessPageGuard, FeatureToggleGuard]),
  },
] as Route[];
